import { render, staticRenderFns } from "./BaseProductTile.vue?vue&type=template&id=fb4b1942&"
import script from "./BaseProductTile.vue?vue&type=script&lang=js&"
export * from "./BaseProductTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb4b1942')) {
      api.createRecord('fb4b1942', component.options)
    } else {
      api.reload('fb4b1942', component.options)
    }
    module.hot.accept("./BaseProductTile.vue?vue&type=template&id=fb4b1942&", function () {
      api.rerender('fb4b1942', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/BaseProductTile.vue"
export default component.exports